<!----------------------------------------------------------------------------------
// <copyright file="app.html" company="ecoInsight, Inc.">
// 	Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------------->
<main class="main">
  <div class="error-handle">{{ 'n.err' | translate }}</div>
  <vs-loader [loading]="loading()" />
  @if (globalService.appInitialized()) {
    <div class="content">
      @if (!production && displayEnv()) {
        <div class="admin-mode">
          <span class="role-mode">
            {{ 'ad.te' | translate }}
          </span>
        </div>
      }
      <router-outlet />
    </div>
  }
</main>
